// extracted by mini-css-extract-plugin
export var active = "_kn-2";
export var recordingDot = "_kn-1";
export var recordingIndicator = "_kn-0";